import styled from "styled-components";
// padding: '8px 16px', borderRadius: 8, marginBottom: 5 
export const AppointmentListItemContainer = styled.div<{isEncaixe: boolean}>`
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${props=>props.isEncaixe? '#E7F3FD':'#FAFAFA'};
    padding: 8px 16px;
    border-radius: 8px;
    margin-bottom: 5px;
`